import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';

import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { NgbCollapseModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { InlineSVGModule } from 'ng-inline-svg';
import { RecaptchaModule } from 'ng-recaptcha';

import { environment } from '../environments/environment';
import { AppComponent } from './app';
import { appRoutes } from './app.routes';
import { SENTRY_PROVIDER } from './app.sentry';

import { ApiProvider } from './core/providers/api';
import { AuthProvider } from './core/providers/auth';
import { DataStore } from './core/providers/data';
import { ErrorProvider } from './core/providers/error';
import { HelperProvider } from './core/providers/helper';
import { SharedStore } from './core/providers/shared';

import { TokenInterceptor } from './core/interceptors/token';

import { NotFoundComponent } from './pages/404/404';
import { HomeComponent } from './pages/home/home';



@NgModule({
	entryComponents: [],
	declarations: [
		AppComponent,

		HomeComponent,

		NotFoundComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		RouterModule.forRoot(appRoutes, { useHash: false }),
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,

		Angulartics2Module.forRoot([ Angulartics2GoogleTagManager ]),
		NgbModalModule.forRoot(),
		NgbCollapseModule.forRoot(),
		InlineSVGModule,
		RecaptchaModule.forRoot(),
		NgSelectModule,
	],
	providers: [
		environment.production ? SENTRY_PROVIDER : [],
		ApiProvider,
		HelperProvider,
		ErrorProvider,
		DataStore,
		SharedStore,
		AuthProvider,
		JwtHelperService,
		{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
		{ provide: JWT_OPTIONS, useValue: {} },
	],
	bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts